export enum ResponseType {
    Pending = 'pending',
    Success = 'success',
    Failed = 'failed',
    Unauthorized = 'unauthorized',
    Forbidden = 'forbidden',
    NotFound = 'not_found',
    ServerError = 'server_error',
    InvalidInput = 'invalid_input',
    Timeout = 'timeout',
    NetworkError = 'network_error',
    PartialSuccess = 'partial_success',
    DuplicateEntry = 'duplicate_entry',
    ValidationError = 'validation_error',
    AccessDenied = 'access_denied',
    TooManyRequests = 'too_many_requests',
    PaymentRequired = 'payment_required',
    ServiceUnavailable = 'service_unavailable',
    MaintenanceMode = 'maintenance_mode',
    Other = 'other',
}
